import React, { useEffect, useState, useContext } from "react";
import { Button, Form, Modal, Row, Col, Spinner } from "react-bootstrap";
import "./AddEditRoleMaster.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { AuthContext } from "../../contexts/AuthContext";
import { getCurrentDateTime, formatDateInDDMMYYYY } from "../../functions/common-functions";
import { ALERT_PARAMS } from "../../utils/constant.js";
import { AddNewContract, getAllContracts, updateContract } from "../../services/contract-master-service.js";
import { addLogDetails } from "../../services/logger-entry-service.js";
// import { getAllActiveLocations, getAllLocations } from "../../services/location-master-service.js";
import SearchSelect from "../common/SearchSelect.jsx";
import SingleValuePopUp from "../utils/SingleValuePopUp.jsx";
import MultiValuePopUp from "../utils/MultiValuePopUp.jsx";
import { BiSelectMultiple } from "react-icons/bi";

const AddEditContractMaster = (props) => {
    const MySwal = withReactContent(Swal);
    const context = useContext(AuthContext);
    const userDetails = { email: context.userEmail, userName: context.userName, userId: context.userId };

    let action = props.action;
    const [toggleClass, setToggleClass] = useState("activeToggleLabel");
    const [loading, setLoading] = useState(false);

    // const [locations, setLocations] = useState([]);
    const [error, setError] = useState({});
    const [originalData, setOriginalData] = useState({});
    const [showItemCodePopup, setShowItemCodePopup] = useState(false);
    const [showLocationPopup, setShowLocationPopup] = useState(false);
    const rowData = props.rowdata

    const [contractObj, setContractObj] = useState(
        action === "Edit" || action === "Copy"
            ? props.rowdata
            : {
                ItemCode: "",
                ItemDescription: "",
                ItemDetail: "",
                Location: [],
                ContractPeriod: "",
                GSTRate: "",
                ContractStartDate: new Date().toISOString().split('T')[0],
                ExpiryDate: "",
                DeleteIndication: "Active"
            }
    );

    useEffect(() => {
        if (action === "Edit" || action === "View") {
            setOriginalData(JSON.parse(JSON.stringify(props.rowdata)));
            if (props.rowdata.DeleteIndication === "Active") {
                setToggleClass("activeToggleLabel");
            } else {
                setToggleClass("inactiveToggleLabel");
            }
        }
        // fetchLocations();
    }, []);

    // const fetchLocations = async () => {
    //     const result = await getAllActiveLocations();
    //     setLocations(result);
    // };

    const handleItemCodeSelect = (data) => {
        setContractObj((prevState) => ({
            ...prevState,
            ItemCode: data.result.ItemCode || data.result,
            ItemDescription: data.result.ItemDescription || "",
            ItemType: data.result.ItemType || ""
        }));
    };

    const handleLocationSelect = (data) => {
        const selectedLocations = data.result.map(loc => loc.Location || loc);
        setContractObj((prevState) => ({
            ...prevState,
            Location: selectedLocations
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (action === "View") {
            props.onHide();
        } else {
            // Validate required fields
            if (!contractObj.ItemCode || contractObj.ItemCode === "") {
                setError({ ItemCode: "Item Code is mandatory" });
                return;
            }
            if (!contractObj.ItemDetail || contractObj.ItemDetail === "") {
                setError({ ItemDetail: "Item Detail is mandatory" });
                return;
            }
            if (!contractObj.Location || contractObj.Location.length === 0) {
                setError({ Location: "Location is mandatory" });
                return;
            }
            if (!contractObj.ContractPeriod || contractObj.ContractPeriod === "") {
                setError({ ContractPeriod: "Contract Period is mandatory" });
                return;
            }
            if (!contractObj.GSTRate || contractObj.GSTRate === "") {
                setError({ GSTRate: "GST Rate is mandatory" });
                return;
            }
            if (parseFloat(contractObj.GSTRate) < 0 || parseFloat(contractObj.GSTRate) > 50) {
                setError({ GSTRate: "GST Rate must be between 0 and 50" });
                return;
            }

            // Check for modifications in Edit mode
            if (action === "Edit") {
                const hasChanges = JSON.stringify(originalData) !== JSON.stringify(contractObj);
                if (!hasChanges) {
                    MySwal.fire({
                        text: "No change in record.",
                        imageUrl: errorImage,
                        customClass: "swal-success",
                    });
                    return;
                }
            }

            let confirmBoxText = "";
            let confirmButtonText = "";
            if (action === "Add" || action === "Copy") {
                confirmBoxText = "Are you sure, do you want to add new contract?";
                confirmButtonText = "Add";
            } else if (action === "Edit") {
                confirmBoxText = "Are you sure, do you want to update contract?";
                confirmButtonText = "Update";
            }

            MySwal.fire({
                text: confirmBoxText,
                confirmButtonText: confirmButtonText,
                title: (action === "Add" || action === "Copy" ? "Add" : action) + " Contract",
                ...ALERT_PARAMS
            }).then(async (result2) => {
                if (result2.isConfirmed) {
                    setLoading(true);
                    let result;

                    if (action === "Add" || action === "Copy") {
                        let todayDate = getCurrentDateTime("-");
                        contractObj.ContractCode = String((props.allContracts.length) + 1)
                        contractObj.CreatedBy = userDetails.userId;
                        contractObj.CreatedByName = userDetails.userName;
                        contractObj.CreatedOn = todayDate;
                        contractObj.ModifiedBy = userDetails.userId;
                        contractObj.ModifiedByName = userDetails.userName;
                        contractObj.ModifiedOn = todayDate;
                        contractObj.PK = "ContractMaster";
                        contractObj.SK = "Contract#" + contractObj.ItemCode + "#" + contractObj.ContractCode;
                        result = await AddNewContract(contractObj);
                        await addLogDetails(contractObj, "Add", contractObj.SK, "ContractMaster", userDetails, "Master");
                    } else if (action === "Edit") {
                        let todayDate = getCurrentDateTime("-");
                        contractObj.ModifiedBy = userDetails.userId;
                        contractObj.ModifiedByName = userDetails.userName;
                        contractObj.ModifiedOn = todayDate;
                        result = await updateContract(contractObj);
                        await addLogDetails(contractObj, "Update", contractObj.SK, "ContractMaster", userDetails, "Master");
                    }
                    
                    setLoading(false);
                    if (result.status) {
                        MySwal.fire({
                            text: (action === "Add" || action === "Copy") ? "Contract inserted successfully" : "Contract updated successfully",
                            imageUrl: successImage,
                            customClass: "swal-success",
                            didClose: () => {
                                props.setreload(!props.reload);
                                props.onHide();
                            },
                        });
                    }
                }
            });
        }
    };

    const handleCancel = () => {
        props.onHide();
    };

    const handleReset = () => {
        if (action === "Add") {
            setContractObj({
                ItemCode: "",
                ItemDescription: "",
                ItemType: "",
                ItemDetail: "",
                Location: [],
                ContractPeriod: "",
                GSTRate: "",
                ContractStartDate: new Date().toISOString().split('T')[0],
                ExpiryDate: "",
                DeleteIndication: "Active"
            });
            setToggleClass("activeToggleLabel");
            setError({});
        }
    };

    const handleSwitchChange = (e) => {
        if (e.target.checked) {
            setToggleClass("activeToggleLabel");
        } else {
            setToggleClass("inactiveToggleLabel");
        }

        setContractObj((prevState) => ({
            ...prevState,
            DeleteIndication: e.target.checked ? "Active" : "Inactive",
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "ItemDetail") {
            const alphanumericRegex = /^[a-zA-Z0-9][a-zA-Z0-9 .\-,]*$|^$/;
            if (!alphanumericRegex.test(value)) {
                return;
            }
        }
        setContractObj((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const isFieldReadOnly = () => {
        if (action === "View") return true;
        if (action === "Edit") return true;
        return false;
    };

    return (
        <>
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <Modal centered
                {...props}
                size="xl"
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modalTitle">
                        {action === "Copy" ? "Add" : action} Contract
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        id="contractmaster"
                        name="contractmaster"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                    >
                        <Row>
                            <Col md={3} sm={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="ItemCode"
                                            type="text"
                                            name="ItemCode"
                                            placeholder=" "
                                            required
                                            value={contractObj.ItemCode}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label" htmlFor="ItemCode">Item Code</Form.Label>
                                        <BiSelectMultiple
                                            className={isFieldReadOnly() ? "d-none" : ""}
                                            size={20}
                                            onClick={() => setShowItemCodePopup(true)}
                                            color={"#707070"}
                                            style={{ marginLeft: "-2rem" }}
                                        />
                                    </div>
                                    {error.ItemCode && (
                                        <Form.Text className="text-danger">
                                            {error.ItemCode}
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={3} sm={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="ItemDescription"
                                        type="text"
                                        name="ItemDescription"
                                        placeholder=" "
                                        value={contractObj.ItemDescription}
                                        readOnly
                                    />
                                    <Form.Label className="frm-label" htmlFor="ItemDescription">Item Description</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col md={6} sm={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        as="textarea"
                                        id="ItemDetail"
                                        name="ItemDetail"
                                        maxLength="200"
                                        placeholder=" "
                                        required
                                        rows={1}
                                        value={contractObj.ItemDetail}
                                        onChange={handleChange}
                                        readOnly={isFieldReadOnly()}
                                    />
                                    <Form.Label className="frm-label" htmlFor="ItemDetail">Item Detail</Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4} sm={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="Location"
                                            type="text"
                                            name="Location"
                                            placeholder=" "
                                            required
                                            value={Array.isArray(contractObj.Location) ? contractObj.Location.join(', ') : contractObj.Location}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label" htmlFor="Location">Location</Form.Label>
                                        <BiSelectMultiple
                                            className={isFieldReadOnly() ? "d-none" : ""}
                                            size={20}
                                            onClick={() => setShowLocationPopup(true)}
                                            color={"#707070"}
                                            style={{ marginLeft: "-2rem" }}
                                        />
                                    </div>
                                    {error.Location && (
                                        <Form.Text className="text-danger">
                                            {error.Location}
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={4} sm={12}>
                                <SearchSelect
                                    id="ContractPeriod"
                                    name="ContractPeriod"
                                    label="Contract Period (months)"
                                    value={contractObj.ContractPeriod}
                                    onChange={handleChange}
                                    data={["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]}
                                    disabled={isFieldReadOnly()}
                                    required
                                    error={error}
                                    setError={setError}
                                />
                            </Col>
                            <Col md={4} sm={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="GSTRate"
                                        type="number"
                                        name="GSTRate"
                                        placeholder=" "
                                        required
                                        min="0"
                                        max="50"
                                        step="0.01"
                                        value={contractObj.GSTRate}
                                        onChange={handleChange}
                                        readOnly={isFieldReadOnly()}
                                    />
                                    <Form.Label className="frm-label" htmlFor="GSTRate">GST Rate %</Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4} sm={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="ContractStartDate"
                                        type="date"
                                        name="ContractStartDate"
                                        placeholder=" "
                                        required
                                        min={new Date().toISOString().split('T')[0]}
                                        value={contractObj.ContractStartDate}
                                        onChange={handleChange}
                                        readOnly={isFieldReadOnly()}
                                    />
                                    <Form.Label className="frm-label" htmlFor="ContractStartDate">Contract Start Date</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col md={4} sm={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="ExpiryDate"
                                        type="date"
                                        name="ExpiryDate"
                                        placeholder=" "
                                        min={contractObj.ContractStartDate}
                                        value={contractObj.ExpiryDate}
                                        onChange={handleChange}
                                        readOnly={action === "View" || (action === "Edit" && rowData.ExpiryDate)}
                                    />
                                    <Form.Label className="frm-label" htmlFor="ExpiryDate">Expiry Date</Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3} sm={12}>
                                <Row>
                                    <Col>
                                        <Form.Label className="fieldLabel">Status</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Switch className={"semiBoldToggleButton " + toggleClass}
                                            label={contractObj.DeleteIndication === "Active" ? "Active" : "Inactive"}
                                            name="DeleteIndication"
                                            checked={contractObj.DeleteIndication === "Active"}
                                            onChange={(e) => {
                                                handleSwitchChange(e);
                                            }}
                                            disabled={action === "View" || action === "Edit"}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        {/* {action === "View" && (
                            <Row>
                                <Col md={3} sm={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            type="text"
                                            value={contractObj.CreatedByName || ""}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label">Inserted By</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col md={3} sm={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            type="text"
                                            value={contractObj.CreatedOn ? formatDateInDDMMYYYY(contractObj.CreatedOn.toString()) : ""}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label">Inserted On</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col md={3} sm={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            type="text"
                                            value={contractObj.ModifiedByName || ""}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label">Modified By</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col md={3} sm={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            type="text"
                                            value={contractObj.ModifiedOn ? formatDateInDDMMYYYY(contractObj.ModifiedOn.toString()) : ""}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label">Modified On</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                        )} */}
                        <br />
                        <Row>
                            <Col md={9} xs={6}>
                                <Row>
                                    <Col md={3} xs={12}>
                                        {action === "View" || action === "Edit" ? null :
                                            <Button className="semiBoldToggleButton cancelBtn"
                                                variant="outline-success"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </Button>
                                        }
                                    </Col>
                                    <Col xs={12} md={3}>
                                        {action === "View" || action === "Edit" || action === "Copy" ? <></> :
                                            <Button className="resetBtn semiBoldToggleButton"
                                                variant="link"
                                                onClick={handleReset}
                                            >
                                                Reset Fields
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3} xs={6}>
                                {action === "View" ?
                                    <Button variant="success" className="btn-add-color semiBoldToggleButton rightAlignedButton" type="submit">
                                        Done
                                    </Button>
                                    :
                                    <Button variant="success" className="btn-add-color semiBoldToggleButton rightAlignedButton" type="submit">
                                        {action === "Edit" ? "Update" : "Add"}
                                    </Button>
                                }
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>

            {showItemCodePopup && (
                <SingleValuePopUp
                    show={showItemCodePopup}
                    onHide={() => setShowItemCodePopup(false)}
                    mastername="Item Master"
                    setSelected={handleItemCodeSelect}
                    paramkey="ItemCode"
                    paramvalue={contractObj.ItemCode}
                />
            )}

            {showLocationPopup && (
                <MultiValuePopUp
                    show={showLocationPopup}
                    onHide={() => setShowLocationPopup(false)}
                    masterName="Location Master"
                    setSelected={handleLocationSelect}
                    selectedItems={Array.isArray(contractObj.Location) ? contractObj.Location.join(', ') : contractObj.Location}
                />
            )}
        </>
    );
};

export default AddEditContractMaster;
